<template>
  <div
    class="sc-message--button"
    style="height: auto"
  >
    <div
      v-if="data.text[0].image && data.text[0].clickeable_img === true"
      class="sc-message--button-img-body clickeable-image"
    >
      <img
        class="sc-message--button-image"
        :src="data.text[0].image"
        @click="openModalImg(data.text[0].image)"
      >
    </div>
    <div
      v-else-if="data.text[0].image"
      class="sc-message--button-img-body"
    >
      <img
        class="sc-message--button-image"
        :src="data.text[0].image"
        alt=""
      >
    </div>
    <div
      v-if="data.text[0].image && data.text[0].clickeable_img"
      class="sc-message--button-icon-footer"
    >
      <img
        src="@/assets/img/miximize-icon.png"
        class="sc-message--button-maximize"
        @click="openModalImg(data.text[0].image)"
      >
    </div>
    <div
      v-if="data.text[0].title"
      class="sc-message--button-text"
      v-html="data.text[0].title"
    />
    <div
      v-if="data.text[0].text"
      class="sc-message--button-subtitle"
      v-html="data.text[0].text"
    />
    <ul class="sc-message--button-control">
      <hr class="sc-message--button-hr">
      <li
        v-for="(btn) in data.text[0].buttons"
        :key="btn.label"
        class="sc-message--button-control-item"
      >
        <a
          :disabled="!canClickButton"
          @click="clickButton($event,btn)"
          v-html="btn.label"
        />
        <hr class="sc-message--button-hr">
      </li>
    </ul>
  </div>
</template>

<script>
import { serverUI } from './main'

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    canClickButton () {
      return this.data.text[0].processClick
    }
  },
  methods: {
    openModalImg (urlImg) {
      const w = window.innerWidth
      if (w > 450) {
        serverUI.$emit('updateModalImg', urlImg)
      }
    },
    clickButton (event, btn) {
      if (this.data.text[0].processClick) {
        if (!event.target.classList.contains('sc-message--button-button-bg')) {
          event.target.classList.toggle('sc-message--button-button-bg')
        }
        btn.event(btn)
      }
    },
    playVoice () {
      const voice_audio = new Audio()
      voice_audio.src = this.data.voice
      voice_audio.type = 'audio/wav'
      voice_audio.autoplay = true
    }
  }
}
</script>
<style scoped>
.sc-message--button {
    height: 100%;
    padding: 10px 0px 0px 0px;
}

.sc-message--button-image {
    display: block;
    margin: auto;
    width: 85%;
    border-radius: 10px 10px 0px 0px;
}

.sc-message--button-subtitle {
    font-size: 15px;
    color: #565656;
    margin: 0px 5px 10px 10px;
}

.sc-message--button-text {
    list-style-type: none;
    color: #336195;
    font-size: 15px;
    margin: 0 10px 10px 10px;
    font-weight: bold;
}

.sc-message--button-hr {
    height: 1px;
    border: 0;
    background-color: #d8d9da;
    width: 100%;
    margin: 0;
    padding: 0;
    outline: none;
}

.sc-message--button-control {
    list-style-type: none;
    padding: 0;
    margin: 0;
}

.sc-message--button-control-item {
    color: #4067aa;
    font-size: 14px;
    line-height: 2em;
    cursor: pointer;
    text-align: left !important;
}

.sc-message--button-control-item a {
    display: block;
    padding: 2% 0;
    text-decoration: none;
    padding-left: 10px;
    font-size: 13px;
    color: #4067aa;
    background-color: #fff;
    line-height: 15px;
}

.sc-message--button-control-item a:hover {
    color: #fff;
    background-color: #4067aa;
}

.sc-message--button-button-bg {
    color: white;
    background-color: rgb(50, 98, 149);
}

.sc-message--button-button:hover {
    text-decoration: underline;
    transition-duration: .2s;
    -webkit-transition-duration: .2s;
    -moz-transition-duration: .2s;
    text-decoration: none;
}

.sc-message--button-img-body {
    min-height: 100px;
    width: 100%;
    display: flex;
    margin: auto;
    align-items: center;
    flex-direction: column;
}
.clickeable-image img { display: flex; }

.sc-message--button-icon-footer {
  width: 85%;
  margin: auto;
  height: 28px;
  background-color: #CCCCCC;
  border-radius: 0px 0px 10px 10px;
  display: flex;
  justify-content: flex-end;
}

.sc-message--button-maximize {
  width: auto;
  height: 100%;
  margin: 1px 3px 0px 0px;
}

</style>
